'use client';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import { Link, LinkProps } from '@natu/next-link';
import { cn } from '@natu/utils/cn';

type CategoryBarLinkProps = LinkProps & {
  children?: ReactNode;
};

export const CategoryBarLink = ({ children, href, className, ...rest }: CategoryBarLinkProps) => {
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      className={cn(
        className,
        'ring-offset-background focus-visible:ring-ring hover:text-primary-600 hover:bg-primary-200 group relative p-3 font-semibold tracking-[-0.2px] transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        isActive && 'text-primary-600 bg-primary-200',
      )}
      {...rest}
    >
      {children}
      <div
        className={cn(
          'group-hover:bg-primary-600 absolute bottom-0 left-0 h-px w-full bg-gray-200 transition-all group-hover:h-[2px]',
          isActive && 'bg-primary-600 h-[2px]',
        )}
      />
    </Link>
  );
};
